export default __webpack_public_path__ + "static/media/freezer-5-bonus.871d7eb4.svg";